import { useState } from 'react';
import cls from 'classnames';
import { ArrowupIcon, ArrowdownIcon } from '@bfe/moly-icons';

import styles from './index.module.less';

const SORT_TYPE_LIST = ['NORMAL', 'UP', 'DOWN'];

interface IProps {
  txt: string;
  sortType: string;
  sortColumn: string;
  onSort: (sortColumn: any, type: string) => void;
}

const SortBtn = ({ txt, sortType, sortColumn, onSort }: IProps) => {
  const [pointFlag, setPointFlag] = useState(false);

  const handleSort = (type: string) => {
    onSort(sortColumn, type);
  };

  return (
    <div className={styles.container}>
      <span
        className={styles.text}
        onClick={() => {
          handleSort(
            pointFlag
              ? 'NORMAL'
              : SORT_TYPE_LIST[(SORT_TYPE_LIST.indexOf(sortType) + 1) % 3]
          );
          setPointFlag(false);
        }}
      >
        {txt}
      </span>
      <div className={styles.btnBg}>
        <ArrowupIcon
          className={cls(styles.btn, {
            [styles.sortType]: sortType === 'UP',
          })}
          onClick={() => {
            setPointFlag(!pointFlag);
            handleSort(pointFlag ? 'NORMAL' : 'UP');
          }}
        />

        <ArrowdownIcon
          className={cls(styles.btnDown, {
            [styles.sortType]: sortType === 'DOWN',
          })}
          onClick={() => {
            setPointFlag(!pointFlag);
            handleSort(pointFlag ? 'NORMAL' : 'DOWN');
          }}
        />
      </div>
    </div>
  );
};

export default SortBtn;
